import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ToastController,
} from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { errMsg } from "../../../text_control/error-msg";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";

export interface Phones {
  numbers: string;
}

export interface TelEN {
  telENName: string;
}

@Component({
  selector: "app-edit-no-taxinvoice",
  templateUrl: "./edit-no-taxinvoice.component.html",
  styleUrls: ["./edit-no-taxinvoice.component.scss"],
})
export class EditNoTaxinvoiceComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  public data = {
    buyer_agree_tmp: "Y",
    buyer_branch_no: "",
    buyer_citizen_id: "",
    buyer_company_name: "นางสาวนิศา ทดสอบ 10",
    buyer_id: "85",
    buyer_main_branch_no: "",
    buyer_passpost_id: "",
    buyer_people_id: "",
    buyer_status: "active",
    buyer_tax_id: "",
    buyer_type: "0",
    buyer_type_desc: "บุคคลธรรมดา",
    template_lang: "TH",
    seller_id: null,
    addr_id: "",
    building_no: "",
    building_name: "",
    house_no: "",
    room_no: "",
    floor: "",
    village_no: "",
    lane: "",
    road: "",
    sub_district: "",
    district: "",
    province: "",
    postcode: "",
    phone: "",
    email: "",
    telEN: "",
    addrENCountry: "",
    addrENPostCode: "",
    addrENProvince: "",
    addrEN: "",
  };

  dataAbbnext: any;
  datastorage: any;
  dataphone: any;
  phone: any = "";
  buyer_agree_tmp: any = "Y";
  dataAbb: any = [];

  redioaddress = "1";
  showaddrTH = true;
  showaddrEN = true;
  showTH = false;
  showEN = false;
  showaddr = false;
  showedit = false;
  shownexts = false;

  emailEN = "";
  telEN = "";
  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN: String = "";
  addrENOther = "";
  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showback = false;
  showrefresh = false;
  showsave = false;
  shownext = false;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  isAddress = false;
  addressline1 = "";

  constructor(
    public apiservice: ApiserviceService,
    public toastController: ToastController,
    public alertController: AlertController,
    public appService: AppService,
    public router: Router,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text_addr = ADDRESS;
    this.text_btn = BTN;
  }

  ngOnInit() {
    this.addressManual = false;
    this.groupAddress = this.appService.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.data.sub_district = item.district;
    this.data.district = item.amphoe;
    this.data.province = item.province;
    this.data.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.data.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.data.postcode = "";
    }
    if (name === "Province") {
      this.data.province = "";
    }
    if (name === "District") {
      this.data.district = "";
    }
    if (name === "SubDistrict") {
      this.data.sub_district = "";
    }
  }
  ionViewDidEnter() {
    this.getStorage();
    this.checkredioaddr();
    this.reloadcountry();
  }
  getStorage() {
    this.reloadcountry();
    this.datastorage = _getStorage(STORAGE.DATA_EDIT_NO__TAXINVOICE);

    if (this.datastorage !== "") {
      let country: any;
      let Address = this.datastorage.address_detail[0];
      country = this.dataCountry.filter(
        (i) => i.name === this.datastorage.address_detail[0].inter_country
      );

      if (country.length > 0) {
        this.addrENCountry = country[0].name + ":" + country[0].code;
      }
      this.isAddress = Address.is_addresstxt;
      this.addressline1 = Address.addressline1;
      this.data = {
        buyer_agree_tmp: this.datastorage.buyer_agree_tmp,
        buyer_branch_no: "",
        buyer_citizen_id: "",
        buyer_company_name: this.datastorage.buyer_company_name,
        buyer_id: this.datastorage.buyer_id,
        buyer_main_branch_no: "",
        buyer_passpost_id: "",
        buyer_people_id: "",
        buyer_status: "active",
        buyer_tax_id: "",
        buyer_type: "3",
        buyer_type_desc: "",
        template_lang: this.datastorage.template_lang,
        seller_id: null,
        addr_id: Address.addr_id,
        building_no: Address.building_no,
        building_name: Address.building_name,
        house_no: Address.house_no,
        village_no: Address.village_no,
        lane: Address.lane,
        room_no: Address.room_no,
        floor: Address.floor,
        road: Address.road,
        sub_district: Address.sub_district,
        district: Address.district,
        province: Address.province,
        postcode: Address.postcode,
        phone: Address.phone,
        email: Address.email,
        addrEN: Address.inter_address_line1,
        addrENCountry: this.addrENCountry,
        addrENPostCode: Address.inter_postcode,
        addrENProvince: Address.inter_province,
        telEN: Address.inter_tel,
      };
      this.dataphone = Address.phone.split(",");
      this.phones = [];
      if (this.dataphone[0] === "") {
        this.dataphone = "";
      }
      for (let i of this.dataphone) {
        this.phones.push({
          numbers: i,
        });
      }
    }
  }

  checkredioaddr() {
    if (this.datastorage.address_detail[0].type_addr === "1") {
      this.redioaddress = "1";
      this.showTH = true;
      this.showEN = true;
      this.showaddr = true;
      this.showedit = true;
      this.showback = true;
      this.shownexts = true;
      this.shownext = false;
    }
    if (this.datastorage.address_detail[0].type_addr === "2") {
      this.redioaddress = "2";
      this.showTH = true;
      this.showEN = true;
      this.showaddr = true;
      this.showedit = true;
      this.showback = true;
      this.shownexts = true;
      this.shownext = false;
    }
  }

  checkaddressTH() {
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.showTH = true;
    this.showEN = false;
  }

  reloadcountry() {
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }

  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }
  checkemail(e) {
    this.data.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  phones: Phones[] = [];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.phones.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(phone: Phones): void {
    const index = this.phones.indexOf(phone);

    if (index >= 0) {
      this.phones.splice(index, 1);
    }
  }

  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.data.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }

  dataTH: any;
  dataEN: any;
  async save() {
    let isConfirm = false;
    let province: any = this.data.province;
    let district: any = this.data.district;
    let sub_district: any = this.data.sub_district;
    let phones = [];

    for (let i of this.phones) {
      phones.push(i.numbers);
    }

    if (this.isAddress === true && this.addressline1 === "")
      return this.ErrorMsg(errMsg.errorAddressline1);

    if (this.isAddress === true && this.data.postcode === "") {
      return this.ErrorMsg(errMsg.postcode);
    }
    if (this.isAddress === true && this.data.buyer_company_name === "") {
      return this.ErrorMsg(errMsg.buyer_company_name);
    }

    if (this.isAddress === false) {
      if (this.redioaddress === "1") {
        if (!isConfirm) {
          let filterPostcode = this.groupAddress.filter(
            (f) => f.zipcode === Number(this.data.postcode)
          );
          let filterProvince = this.groupAddress.filter(
            (f) => f.province === this.data.province
          );

          if (this.data.buyer_company_name === "") {
            this.ErrorMsg(errMsg.buyer_company_name);
          } else if (this.data.house_no === "") {
            this.ErrorMsg(errMsg.house_no);
          } else if (this.data.postcode !== "" && filterPostcode.length === 0) {
            this.ErrorMsg(errMsg.notpostcode);
          } else if (sub_district === "") {
            this.ErrorMsg(errMsg.sub_district);
          } else if (district === "") {
            this.ErrorMsg(errMsg.district);
          } else if (province === "") {
            this.ErrorMsg(errMsg.province);
          } else if (province !== "" && filterProvince.length === 0) {
            this.ErrorMsg(errMsg.notprovince);
          } else {
            isConfirm = true;
          }
        }
      } else {
        if (!isConfirm) {
          if (this.data.buyer_company_name === "") {
            this.ErrorMsg(errMsg.buyer_company_name);
          } else if (
            this.data.addrENProvince === "" ||
            this.data.addrENProvince === undefined
          ) {
            this.ErrorMsg(errMsg.addrENProvince);
          } else if (
            this.data.addrENPostCode === "" ||
            this.data.addrENPostCode === undefined
          ) {
            this.ErrorMsg(errMsg.addrENPostCode);
          } else if (
            this.data.addrENCountry === "" ||
            this.data.addrENCountry === undefined
          ) {
            this.ErrorMsg(errMsg.addrENCountry);
          } else {
            isConfirm = true;
          }
        }
      }
    } else {
      isConfirm = true;
    }

    if (isConfirm) {
      const data = {
        updateCustomerData: {
          buyer_id: this.data.buyer_id,
          buyer_company_name: this.data.buyer_company_name,
          buyer_people_id: null,
          buyer_main_branch_no: this.data.buyer_main_branch_no,
          buyer_branch_no: this.data.buyer_branch_no,
          buyer_citizen_id: this.data.buyer_citizen_id,
          buyer_tax_id: this.data.buyer_tax_id,
          buyer_type: this.data.buyer_type,
          buyer_passpost_id: this.data.buyer_passpost_id,
          buyer_agree_tmp: this.data.buyer_agree_tmp,
          user_id: this.userID,
          buyer_status: this.data.buyer_status,
          template_lang: this.redioaddress === "1" ? "TH" : "EN",
          address_detail: {
            addr_id: this.data.addr_id,
            building_no: this.data.building_no,
            building_name: this.data.building_name,
            house_no: this.data.house_no,
            village_no: this.data.village_no,
            room_no: this.data.room_no,
            floor: this.data.floor,
            lane: this.data.lane,
            road: this.data.road,
            sub_district: sub_district === undefined ? "" : sub_district,
            district: district === undefined ? "" : district,
            province: province === undefined ? "" : province,
            postcode: String(this.data.postcode),
            phone: phones.join(","),
            email: this.data.email,
            buyer_id: this.data.buyer_id,
            address_status: this.data.buyer_status,
            seller_id: "",
            addr_agree_tmp: this.buyer_agree_tmp,
            user_id: this.userID,
            type_addr: this.redioaddress,
            inter_address_line1:
              this.data.addrEN === undefined ? "" : this.data.addrEN,
            inter_country: this.data.addrENCountry,
            inter_fax: "",
            inter_postcode: this.data.addrENPostCode,
            inter_province: this.data.addrENProvince,
            inter_tel: this.data.telEN === undefined ? "" : this.data.telEN,
            is_addresstxt: this.isAddress,
            addressline1: this.addressline1 || "",
          },
        },
      };
      console.log("[========= req data confirm edit============]", data);

      try {
        this.apiservice
          ._post(this.apiservice.apiUrl + this.apiservice.updateCustomer, data)
          .then(async (res: any) => {
            console.log("[------res data save--------]", res);
            if (res.statusCode === 200) {
              this.dataAbb = res.data[0];
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.showTH = true;
                      this.showEN = true;
                      this.showaddr = true;
                      this.showrefresh = false;
                      this.showsave = false;
                      this.showback = false;
                      this.shownext = true;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }
  editdata() {
    if (this.redioaddress === "1") {
      this.showTH = false;
      this.showEN = true;
      this.showaddr = false;
      this.showedit = false;
      this.showback = true;
      this.showsave = true;
      this.shownexts = false;
      this.showaddrTH = false;
      this.showaddrEN = false;
    }
    if (this.redioaddress === "2") {
      this.showTH = true;
      this.showEN = false;
      this.showaddr = false;
      this.showedit = false;
      this.showback = true;
      this.showsave = true;
      this.shownexts = false;
      this.showaddrTH = false;
      this.showaddrEN = false;
    }
  }
  backNotaxinvoice() {
    this.router.navigate(["/select-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }
  setnextstorage() {
    _setStorage(STORAGE.DATA_ADD_NO__TAXINVOICE, this.dataAbb);
    _setStorage(STORAGE.DATA_SELECT_NO_TAXINVOICE, [this.dataAbb]);
    this.router.navigate(["/check-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }
  nextAbb() {
    _setStorage(STORAGE.DATA_ADD_NO__TAXINVOICE, this.datastorage);
    this.router.navigate(["/check-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }
}
